import {
  DEALER_TYPE_ABBR_AD,
} from '@/apis/server/new-car/v1/promotion-shortlist-form/constants';

import type { GetPromotionCarCode } from './types';

export const getPromotionCarCode: GetPromotionCarCode = ({
  carId,
  dealerTypeAbbr,
}) => (!carId || (dealerTypeAbbr === DEALER_TYPE_ABBR_AD) ? '' : String(carId));
